/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/icon.css'
import './styles.scss'
import { TypescriptComponent } from 'components/typescriptExample'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { SideElement } from '../sideelment'
import { Stamp } from '../stamp'
import { Step } from '../step'
import { Image, Link } from '@ta-interaktiv/contentbricks'
import { AutofitIFrame } from '@ta-interaktiv/react-autofit-iframe'
import { browserCheck } from '@ta-interaktiv/browsercheck'
import Cover from 'components/cover'

// TODO Set the correct article ID here
const ARTICLE_ID = '526877872769'

const isMobile = window.innerWidth < 600
const isTablet = window.innerWidth >= 600 && window.innerWidth <= 1024

export function AppComponent() {
  return (
    <div className='index'>
      <Masthead articleId={ARTICLE_ID} inverted />
      <ThemeSwitch />

      <Cover
        title={
          isMobile
            ? 'Mit dem Flixbus zurück ins Kriegsgebiet'
            : 'Mit dem Flixbus zurück ins Kriegsgebiet'
        }
        subtitle={
          isMobile
            ? 'Für 29.50 Franken: Die grünen Busse fahren wieder in die Ukraine. Darin sitzen viele Ukrainerinnen mit One-Way-Ticket. Wer sind diese Menschen? Eine 15-Stunden-Fahrt von Warschau nach Kiew.'
            : 'Für 29.50 Franken: Die grünen Busse fahren wieder in die Ukraine. Darin sitzen viele Ukrainerinnen mit One-Way-Ticket. Wer sind diese Menschen? Eine 15-Stunden-Fahrt von Warschau nach Kiew.'
        }
        // author='Christoph Lenz'
      />
      {/* <figcaption className='ui container'>Fotos: Fabian Hugo</figcaption> */}

      {/* <header className='ui vertical very fitted segment header'>
        <div className='gallery'>
          <div className='gradient' />
          <div className='ui container inverted headerWrapper'>
            <div className='ui header'>
              <h1>Exklusive Reportage - Mit dem Flixbus ins Kriegsgebiet</h1>
              <h2>
                Der Billiganbieter Flixbus fährt wieder in die Ukraine.
                Hauptstrecke ist Warschau-Kiew. Die Busse sind ständig voll
                belegt mit Passagieren, die vorwiegend ein One-Way-Ticket haben.
                Wer sind diese Menschen, die zurückkehren?
              </h2>
            </div>
          </div>
        </div>
      </header> */}

      <div className='ui vertical segment'>
        <div className='ui text container'>
          <div className='ta metainfo'>
            <div className='ta author'>Yann Cherix</div>
            <div className='ta updated'>Aktualisiert am 28. Mai 2022</div>
          </div>
          <div className='ta text'>
            <p>
              Kurz vor Kiew kippt die Stimmung. In den 13 Sitzreihen macht sich
              kollektive Fassungslosigkeit breit. Alle 54 Buspassagiere schauen
              aus dem Fenster und sehen eine vom Krieg gezeichnete Landschaft
              vorbeiziehen. Verkohlte Birken, ausgebrannte Häuser, zerfetzte
              Strassenschilder.
            </p>
            <p>
              Und ziemlich genau dort, wo laut Google Maps die Kiewer
              Bezirksgrenze beginnt, stehen zwei ausgebrannte Panzer im
              Strassengraben. Hier wurde die russische Armee auf ihrem Vormarsch
              zur ukrainischen Hauptstadt zurückgedrängt. Auf der E40, der
              westlichen Hauptverkehrsachse, gab es heftige Kämpfe. Es ging um
              viel, vielleicht um alles. Kiew durfte nicht fallen. Mitte März
              war das.
            </p>
          </div>
        </div>

        <div className='ui container'>
          <Image
            file={require('../../images/DSC0757-1.jpg')}
            className='cbImage tour'
            // aspectRatio={browserCheck.isMobile ? '4:3' : '16:9'}
            source='Liliana Kravschenko, 34, Salesmanagerin: «Das macht mich unfassbar traurig.» Foto: Yann Cherix'
          />
        </div>
        <div className='ui ta text container'>
          <p>
            Damals war auch Liliana Kravschenko auf dieser Strasse, jedoch in
            der Gegenrichtung. Die E40 sollte sie in den sicheren Westen
            bringen. Nach Polen. Die Managerin aus Kiew hat den von Norden
            heranrückenden russischen Soldaten wohl gerade noch ausweichen
            können. Die 34-Jährige sieht die Zeichen des Krieges an diesem
            Nachmittag zum ersten Mal. Sie sagt: «Das macht mich unfassbar
            traurig.»
          </p>
          <p>
            Keine Tränen. Nur dieser harte, starre Blick durchs Busfenster. Es
            ist kurz vor 13 Uhr. Noch eine Stunde bis Kiew.
          </p>
        </div>
      </div>
      <div className='ui vertical fitted segment'>
        <div className='ui ta text container'>
          <Step title='Warschau' km='827' time='23.15' unit='Uhr' icon='bus' />

          <AutofitIFrame
            showLoader
            src={
              browserCheck.isMobile
                ? '//datawrapper.dwcdn.net/1SQ1W/'
                : '//datawrapper.dwcdn.net/aSkWn/'
            }
          />

          {/* <Step time='22' unit='Uhr' title='Wahrschau West' icon='' /> */}
          <p>
            14 Stunden zuvor. Der Flixbus Richtung Kiew wirkt am Busbahnhof
            Zachodni wie aus einer anderen Zeit, der Zukunft. Grün und glänzend
            steht er da in der Nacht. Dagegen atmet der Warschauer Stadtrand
            noch den Geist des früheren Ostens: Der Verputz bröckelt, die
            Werbeschilder sind altmodisch.
          </p>
          <p>
            Menschen mit Gepäck fast so gross wie Kühlschränke stehen spätabends
            auf den Plattformen. Und scheinen ewig schon zu warten. Busse mit
            Abertausenden Kilometern unter der Haube rollen heran, rumpeln
            wieder los. Ins lettische Riga, in den Nordosten Polens. Warschau
            war schon immer ein Tor zum Osten. Ein Bus geht heute auch nach
            Charkiw, Ostukraine.{' '}
          </p>
        </div>
        <div className='ui ta container'>
          <Image
            file={require('../../images/MN_FlixBus_006.jpg')}
            className='cbImage travel'
            // aspectRatio={browserCheck.isMobile ? '4:3' : '16:9'}
            source='Startpunkt Busbahnhof Zachodni in Warschau. Die Zukunft ist grün und glänzend. Foto: Maciek Nabrdalik'
          />
        </div>
        <div className='ui ta text container'>
          <p>
            Die deutsche Firma Flixbus ist nicht das einzige
            Transportunternehmen, das in diesen Tagen vom Knotenpunkt Warschau
            aus ins Kriegsgebiet fährt. Aber es ist sicher das im Westen
            bekannteste. Und das am besten organisierte. Tickets gibts nur
            online, die QR-Codes werden in Sekundenschnelle vom
            Flixbus-Mitarbeiter eingelesen. Die Abfahrt ist pünktlich auf die
            Minute. Ab 29.50 Franken.
          </p>
          <p>
            Der Bus ist voll. Fast ausnahmslos Frauen, ein paar wenige Kinder.
            Liliana Kravschenko richtet sich gerade ein. Wasserflasche, Kissen,
            Smartphone. Platz 13A. Letzte Reihe. Ein bisschen mehr Beinfreiheit.
            «Guter Platz», sagt sie und lächelt schwach.
          </p>
          <p>
            Es wird eine lange Fahrt. 15 Stunden bis Kiew. Am Ende winkt das
            Wiedersehen mit der Familie, mit Freunden. Und sie wird auch in ihre
            Einzimmerwohnung mitten in Kiew reinschauen. Ihre Dinge, ihr Leben
            sind dort eingelagert seit dem Tag ihrer Flucht. Ob sie weiterhin
            die 200 Euro pro Monat für die Wohnung aufbringen will, weiss sie
            nicht. Den Job als Salesmanagerin hat sie längst verloren. Jeder
            dritte Arbeitsplatz soll in der Ukraine mittlerweile verschwunden
            sein.
          </p>
          <p>
            Liliana Kravschenko lebt vom Ersparten. Flüchtlingsstatus hat sie
            nicht. Sie war in zu vielen verschiedenen Ländern, Italien, Spanien,
            Polen. Sie kam bei Bekannten unter, blieb zuweilen nur ein paar
            Tage. Eine einzige Tasche hatte sie jeweils zu packen. Und nun geht
            es erstmals wieder nach Hause. Über zwei Monate war Kravschenko weg.
            Ob sie in der Ukraine bleiben wird, weiss sie nicht. Alles sei
            ungewiss. «Ach», sagt sie, «ich weiss nur, dass ich dringend ein
            paar meiner Kleider brauche.»
          </p>
        </div>
      </div>
      <div className='ui vertical fitted segment'>
        <div className='ui text container'>
          <Step title='Lublin' km='654' time='0.46' unit='Uhr' icon='bus' />
        </div>

        {/* <div className='ui vertical fitted segment map'>
          <AutofitIFrame
            showLoader
            src={
              browserCheck.isMobile
                ? '//datawrapper.dwcdn.net/A6pKb/'
                : '//datawrapper.dwcdn.net/I8Sby/'
            }
          />
        </div> */}

        <div className='ui ta text container'>
          {/* <SideElement side='left'>
            <Stamp time='1:05' unit='Uhr' />
          </SideElement>
          <div className='infobox'>
            <h3>Lublin, Bhf</h3>
            <i className='icon car' />
            176 km
          </div> */}

          <p>
            Wir erreichen die letzte grosse polnische Stadt vor dem
            Grenzübertritt. In Lublin, 340’000 Einwohner, hält der Bus nur kurz.
            In der Universitätsstadt östlich der Weichsel herrschte nach
            Kriegsausbruch Ende Februar Ausnahmezustand, Tausende Flüchtlinge
            aus der Ukraine strandeten hier, zogen weiter, einige blieben. Die
            Heimat ist hier nur eine Stunde entfernt. «Es war Wahnsinn, Chaos»,
            sagen alle, die von diesen Tagen nach Kriegsausbruch erzählen.
          </p>
          <p>
            6,4 Millionen Ukrainerinnen und Ukrainer sind heute auf der Flucht,
            Polen hat mit rund 4,3 Millionen von allen Ländern am meisten
            aufgenommen. Dazu kommen über acht Millionen, die innerhalb der
            Ukraine unterwegs sind - eine enorme Masse von ruhelosen,
            heimatlosen Menschen. Und gerade zieht es viele wieder in Richtung
            Heimat, mit den wieder regelmässig fahrenden Zügen, mit privaten
            Autos, mit Bussen. Gesicherte Zahlen dazu gibt es nicht.
          </p>
          <p>
            Flixbus teilt auf Anfrage mit, dass die Zahl der in die Ukraine
            Reisenden stark zunimmt. 30 wöchentliche Direktverbindungen bieten
            das Unternehmen an. Und alle seien schnell ausgebucht. Was Flixbus
            zudem registriert: Mehr als die Hälfte der Fahrgäste buchen nur die
            Hinfahrt.
          </p>
          <p>
            Im Flixbus N3222 nach Kiew hat kaum jemand der 54 Passagiere ein
            Retourticket.Ist das ein Indiz, dass in weiten Teilen der Ukraine
            der Krieg vorbei ist? In der Schweiz hat die SVP kürzlich die Idee
            lanciert, dass nur noch Menschen aus Gebieten mit Kriegshandlungen
            den Status S erhalten sollten.
          </p>
          <p>
            Doch wo im riesigen Land fallen gerade Bomben?
          </p>
          <p>
            Sveta Salventschuk hat dazu keine Antwort. Die Lehrerin ist mit
            ihrer Schwester unterwegs und will zu Hause nach dem Rechten
            schauen. Während ihre Schwester nach ein paar Tagen wieder zurück
            nach Polen will, ist sich Sveta Salventschuk da noch nicht sicher.
            «Es kommt darauf an, wie die Lage ist», sagt sie. Derzeit sei es,
            höre sie von Bekannten vor Ort, bei ihr zu Hause ruhig. Nur noch
            einmal pro Tag gebe es Luftalarm, erklärt sie und nickt beflissen,
            so als wolle sie sich selbst beruhigen.
          </p>
        </div>
        <div className='ui ta text container'>
          <Image
            file={require('../../images/DSC0773.jpg')}
            className='cbImage travel'
            // aspectRatio={browserCheck.isMobile ? '4:3' : '16:9'}
            source='Sveta Salventschuk, Lehrerin: «Ich muss es mit eigenen Augen sehen.» Foto: Yann Cherix'
          />
        </div>
        <div className='ui ta text container'>
          <p>
            Sveta Salventschuk kommt aus Klawdijewo-Tarassowe, einem Dorf
            zwischen Borodjanka und Butscha. Beide Orte erlangten weltweit
            traurige Berühmtheit, als erstmals von Massengräbern berichtet
            wurde. Wie es der Lehrerin dort ergangen ist, will sie nicht
            erzählen. «Noch nicht», sagt sie und zeigt nach vorne. Gleich kommt
            der Zoll.
          </p>
          <p>
            Der Bus fährt minutenlang an einer stehenden Autokolonne vorbei. Es
            sind zumeist kleinere Transporter, die ein, zwei Personenwagen
            aufgeladen haben. Später wird klar, warum: Die Ukraine hat praktisch
            die Einfuhrsteuern erlassen. Noch nie war der polnisch-ukrainische
            Autohandel lukrativer. Dafür nehmen diese Leute Wartezeiten von bis
            zu vier Tagen in Kauf. Der Krieg produziert unerwartete Gewinner.
          </p>
        </div>
      </div>

      <div className='ui vertical fitted segment'>
        <div className='ui text container'>
          <Step title='Dorohusk' km='559' time='2.33' unit='Uhr' icon='bus' />
        </div>

        <div className='ui vertical fitted segment map' />

        <div className='ui ta text container'>
          <AutofitIFrame
            showLoader
            src={
              browserCheck.isMobile
                ? '//datawrapper.dwcdn.net/Hpgpy/'
                : '//datawrapper.dwcdn.net/fpWPw/'
            }
          />
          <p>
            Der Zoll am Grenzfluss Bug ist zäh. Mehrmals muss die
            Fahrgemeinschaft aus dem Bus aussteigen, die Pässe zeigen. Die
            endlosen Wartezeiten bleiben unerklärlich. Eine Frau im Bus erzählt,
            dass das noch gar nichts sei. Sie habe auch schon acht Stunden
            gewartet.
          </p>
        </div>
        <div className='ui ta container'>
          <Image
            file={require('../../images/DSC0763.jpg')}
            className='cbImage travel'
            // aspectRatio={browserCheck.isMobile ? '4:3' : '16:9'}
            source='Am Zollübergang bei Dorohusk. Zwei Stunden Wartezeit. Andere stehen vier Tage an der polnisch-ukrainischen Grenze. Foto: Yann Cherix'
          />
        </div>
        <div className='ui ta text container'>
          <p>
            Zwei motivierte Mitarbeiterinnen der Caritas stehen unter einem
            blauen Zelt in der Zone zwischen den beiden Ländern und bieten Tee
            und Suppe an. Kaum jemand nimmt das Angebot an. Mit müden Augen
            stehen die Reisenden da in der nächtlichen Frische und warten auf
            Einlass in ihr Land. Manche von ihnen haben nicht einmal die
            aufblasbaren Nackenkissen abgelegt.
          </p>
          <p>
            Nach knapp zwei Stunden darf der Bus schliesslich den Schlagbaum
            passieren, gleich daneben weht die erste ukrainische Flagge.
            «Laskavo prosimo do Ukraini». Willkommen in der Ukraine. Im Bus bleibt
            es still. Da und dort leuchtet das blasse Licht eines Smartphones
            auf. Die meisten versuchen zu schlafen.
          </p>
        </div>
      </div>

      <div className='ui vertical fitted segment'>
        <div className='ui text container'>
          <Step title='Luzk' km='419' time='6.12' unit='Uhr' icon='bus' />
        </div>

        <div className='ui vertical fitted segment map' />

        <div className='ui ta text container'>
          {/* <AutofitIFrame showLoader src='//datawrapper.dwcdn.net/Hpgpy/' /> */}
          <p>
            Ein erster Stopp in der Ukraine. Einige nutzen die Minuten, um sich
            die Beine zu vertreten. Der einzige Kiosk am Busbahnhof ist zu. Die
            Stadt im Nordwesten des Landes gehörte früher zu Litauen, zu Polen, zu
            Russland, dann wieder zu Polen, wurde von den Deutschen besetzt, war
            Teil der Sowjetunion und wurde 1991 der Ukraine einverleibt. Ein
            stattlicher Burgturm ist das Wahrzeichen der während Jahrhunderten
            umkämpften Stadt.
          </p>
          <p>
            Mitte März bombardierten die Russen den Luzker Militärflughafen.
            Seither blieb es weitgehend ruhig. Ob das so bleibt, weiss niemand.
            Während der Fahrt poppt auf den Smartphone-Bildschirmen die
            Nachricht auf, dass im nahen Lwiw in der Westukraine wieder
            regelmässig Bomben niedergegangen sind.
          </p>
        </div>
      </div>

      <div className='ui vertical fitted segment'>
        <div className='ui text container'>
          <Step title='Riwne' km='346' time='7.20' unit='Uhr' icon='bus' />
          <AutofitIFrame
            showLoader
            src={
              browserCheck.isMobile
                ? '//datawrapper.dwcdn.net/ccJaW/'
                : '//datawrapper.dwcdn.net/SKSvJ/'
            }
          />
        </div>

        <div className='ui ta text container'>
          {/* <AutofitIFrame showLoader src='//datawrapper.dwcdn.net/Hpgpy/' /> */}
          <p>
            Sveta Salventschuk ist inzwischen wach. Beim Stopp in Riwne, nach
            einem ersten Kaffee, beginnt die Lehrerin zu erzählen. Sie, die
            zwischen Borodjanka und Butscha ausharren musste, will nun ihre
            Geschichte loswerden, auch wegen der aktuellen Lage in Lwiw. Alles
            kommt wieder hoch, ständig sind da diese Bilder. Sie seufzt. «Man
            lernt mit diesem Luftalarm zu leben. Und man stumpft schnell ab. In
            den ersten Tagen mussten wir zwei- bis dreimal pro Nacht in den
            Schutzkeller. Anfänglich in Panik, irgendwann nur noch
            desillusioniert. Die Kinder wurden apathisch.» Und dann sei am 27.
            Februar der Anruf einer Freundin gekommen. Diese erzählte von 100
            russischen Panzern, die im Nachbardorf stünden. Sveta Salventschuk,
            ihre Schwester und deren Kinder packten sofort das Nötigste ein und
            machten sich auf in den Westen.
          </p>
          <p>
            Was danach rund um Klawdijewo-Tarassowe, Salventschuks Dorf,
            geschah, erfuhr die Weltöffentlichkeit erst, als der russische
            Angriff im Nordwesten der Ukraine abgewehrt werden konnte und erste
            Journalisten vor Ort waren. Butscha wurde zum Synonym der russischen
            Kriegsverbrechen.
          </p>
          <p>
            Klawdijewo-Tarassowe aber, nur zehn Kilometer von Butscha entfernt,
            soll weitgehend verschont worden sein. Keine Plünderungen, keine
            Exekutionen, keine Zerstörung. Sie habe gehört, sagt Sveta
            Salventschuk, dass die Russen eine veraltete Karte gehabt und so ihr
            Dorf übersehen hätten. «Das wäre schlicht ein Wunder. Ich muss es
            mit eigenen Augen sehen.»
          </p>
        </div>
      </div>

      <div className='ui vertical fitted segment'>
        <div className='ui text container'>
          <Step title='Schitomir' km='157' time='9.30' unit='Uhr' icon='bus' />
        </div>

        <div className='ui ta text container'>
          {/* <AutofitIFrame showLoader src='//datawrapper.dwcdn.net/Hpgpy/' /> */}
          <p>
            Die Stadt ist ein wichtiger Verkehrsknotenpunkt. Und sie ist stark
            von der ukrainischen Armee gesichert. Der Flixbus passiert gleich
            mehrere Checkpoints mit Panzersperren. Junge Soldaten mit Gewehren
            stehen vor Mauern aus Sandsäcken, darüber Tarnnetze. Im ukrainischen
            Fernsehen wird am Abend ein Beitrag gesendet, der von der heroischen
            Handarbeit der Frauen berichtet. An die Netze nähen sie alte
            Stofffetzen und verhelfen so der Armee zu besserer Camouflage.
          </p>
          <p>
            Als der Bus die Kaserne von Schitomir kreuzt, entweicht jemandem aus
            einer vorderen Reihe ein erstauntes «Ho!». Gegenüber der Kaserne ist
            eine ganze Häuserzeile zerstört. Es sind auf dieser Reise die ersten
            sichtbaren Spuren des Krieges.
          </p>
          <p>
            Der Ausruf kommt von Igor (17). Der junge Mann ist mit seiner Mutter
            unterwegs. Sie leben in der Nähe des Flughafens Gostomel, eines der
            ikonischen Kampfschauplätze der Ukraine. Als die ersten russischen
            Elitesoldaten auf dem Flughafengelände aufsetzten, war Igor noch in
            der Nähe. Dann flüchteten sie. Der Vater, ein Kriegsveteran, blieb.
          </p>
          <p>
            Igor soll im Sommer eine Ausbildung bei der ukrainischen Marine
            anfangen. Darum müssen sie zurück. Danach bleibt der Teenager vier
            Monate auf See, vier Monate zu Hause. «Das ist meine Zukunft», sagt
            er tonlos.
          </p>
        </div>
        <div className='ui ta container'>
          <Image
            file={require('../../images/DSC0751-1.jpg')}
            className='cbImage travel'
            // aspectRatio={browserCheck.isMobile ? '4:3' : '16:9'}
            source='Igor, 17 Jahre alt (vorne links): «Ich hatte Ambitionen.» Foto: Yann Cherix'
          />
        </div>
        <div className='ui ta text container'>
          <p>
            Eigentlich würde er lieber Taekwondo-Profi werden. Der koreanische
            Kampfsport ist seine Leidenschaft. «Ich habe viele Medaillen
            gewonnen, eine auch hier in Schitomir.» Er zeigt nach draussen.
            Junge Männer in Kampfuniform sind zu sehen. Mit ernsten Mienen
            stehen sie vor den Checkpoints. «Ich hatte Ambitionen.» Igor scheint
            nicht zu realisieren, dass er in der Vergangenheitsform spricht.
          </p>
        </div>
      </div>

      <div className='ui vertical fitted segment'>
        <div className='ui text container'>
          <Step title='Kaliniwka' km='64' time='11.45' unit='Uhr' icon='bus' />
        </div>

        <div className='ui ta text container'>
          {/* <AutofitIFrame showLoader src='//datawrapper.dwcdn.net/Hpgpy/' /> */}
          <p>
            Hier kreuzt die Schnellstrasse E40 eine Regionalstrasse, die nach
            Borodjanka führt. Knapp 30 Kilometer sind es bis zur Stadt, die
            massiv bombardiert wurde. Mindestens 40 Zivilisten wurden dabei
            getötet. Es gibt Berichte von Massenvergewaltigungen durch russische
            Soldaten, Teile von Borodjanka sind noch immer vermint.
          </p>
          <p>
            Der Flixbus rast an dieser Kreuzung vorbei. Aber nicht am Grauen.
            Auch die Schnellstrasse kurz vor Kiew war Kriegsschauplatz.
            Anastasia wird das in Kürze selbst sehen. Dennoch sitzt sie
            entspannt auf Sitz 8B und erzählt von ihren Plänen. Wie Igor ist sie
            17. Und wie das Taekwondo-Talent hat sie Ambitionen. Sie wählt dazu
            aber eine andere Zeitform.
          </p>
          <p>
            «Ich werde meine unterbrochenen Abschlussprüfungen wieder
            aufnehmen», sagt Anastasia. Mathematik, Geschichte und Literatur
            stehen noch aus. Sie wird gute Noten machen, da ist sie sich sicher.
            «Ich war immer schon eine gute Schülerin.» Im Juli will Anastasia
            dann an die Universität. An welche? «Die Kiewer natürlich!»
          </p>
        </div>
        <div className='ui ta container'>
          <Image
            file={require('../../images/DSC0794.jpg')}
            className='cbImage travel'
            // aspectRatio={browserCheck.isMobile ? '4:3' : '16:9'}
            source='Anastasia (17): «Ich beginne im Juli mein Studium – an der Kiewer Universität.» Foto: Yann Cherix'
          />
        </div>
        <div className='ui ta text container'>
          <p>
            Die 17-Jährige eifert ihrer Mutter nach. Diese hat Karriere bei der
            Nationalbank in Kiew gemacht. Die Bank hat die wichtigsten
            Mitarbeiterinnen und Mitarbeiter nun zurückbeordert.
          </p>
          <p>
            Noch eine Stunde bis Kiew. Anastasia sieht jetzt durchs Fenster die
            Mahnmale des Krieges: die verkohlten Birken, schliesslich die zwei
            ausgebrannten Panzer. Im Gegensatz zu Liliana Kravschenko, die ein
            paar Sitzreihen hinter ihr von der kollektiven Fassungslosigkeit im
            Bus ergriffen ist, bleibt der Teenager stoisch. Für sie sind diese
            Zerstörungen Zeichen eines bereits vergangenen Kriegs und vor allem
            eines: Symbol für die Widerstandskraft der Ukrainer.
          </p>
        </div>
      </div>

      <div className='ui vertical fitted segment'>
        <div className='ui text container'>
          <Step title='Kiew' time='14.14' unit='Uhr' icon='' />
          <AutofitIFrame
            showLoader
            src={
              browserCheck.isMobile
                ? '//datawrapper.dwcdn.net/C5Ey1/'
                : '//datawrapper.dwcdn.net/8n9n9/'
            }
          />
        </div>

        <div className='ui ta text container'>
          {/* <AutofitIFrame showLoader src='//datawrapper.dwcdn.net/Hpgpy/' /> */}
          <p>
            Absurd pünktlich trifft der Flixbus N3222 am Kiewer Busbahnhof ein.
            Genau 15 Stunden waren die 54 Passagiere unterwegs. Sie stolpern nun
            alle in die Maisonne. Menschen flanieren vorbei, ein Strassenmusiker
            spielt westliche Hits auf einer Geige. Während die Kiewer Filialen
            von McDonald’s zubleiben, haben die meisten Restaurants offen. In
            der vegetarischen Sandwich-Bar Orang+Utan beisst das junge Partyvolk
            auf Seitan und Tofu. Um acht schliessen aber alle Lokale,
            Ausgangssperre ist um 23 Uhr.
          </p>
          <p>
            Es wird eine Kiewer Nacht werden ohne
            Sirenenalarm. Das ist allerdings eher die Ausnahme.
          </p>
        </div>
        <div className='ui ta container'>
          <Image
            file={require('../../images/DSC0806.jpg')}
            className='cbImage travel'
            // aspectRatio={browserCheck.isMobile ? '4:3' : '16:9'}
            source='Endstation Kiew. Die 54 Passagiere des Flixbus N3222 steigen nach der 15-Stunden-Fahrt aus. Foto: Yann Cherix '
          />
        </div>
        <div className='ui ta text container'>
          <p>
            Der Busfahrer stellt den Motor ab. Feierabend auch für ihn.
            Anastasia wird mit ihrer Mutter nach Hause gehen. Der Vater und die
            Grossmutter warten im Norden der Stadt. Die Musterschülerin wird
            kommende Woche ihre Prüfungen ablegen.
          </p>
          <p>
            Liliana Kravschenko, die Salesmanagerin, wird in ihre
            Einzimmerwohnung gehen. Sie hat mit ihrem Vermieter einige Dinge zu
            besprechen.
          </p>
          <p>
            Sveta Salventschuk will endlich zu ihrem intakten Dorf
            Klawdijewo-Tarassowe. Die Lehrerin wird mit eigenen Augen das Wunder
            sehen.
          </p>
          <p>
            Und Igor überlegt sich, mit Taekwondo aufzuhören. Wenn sein Club den
            Betrieb wieder aufnehmen sollte, ist er längst in der Marineschule.
            Heute aber will er zuerst einmal eine Borschtsch-Suppe essen, das
            ukrainische Nationalgericht. Und er will seinen Vater umarmen.
          </p>
        </div>
      </div>

      <Footer
        articleId={ARTICLE_ID}
        credits={[
          ['Text', 'Yann Cherix'],
          ['Digitales Konzept', 'Patrick Vögeli']
        ]}
        questions={[
          'Wie informativ war der Beitrag?',
          'Wie gefällt Ihnen die Gestaltung?'
        ]}
      />
    </div>
  )
}
